// getDiamondPackData.js
// TODO: change filename to getSkuData
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { SHOP_REWARD_BADGES } from '../RemoteConfigKeys.js';

/**
 * Select diamond pack data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - diamond pack id (product id).
 * @param {string} dataKey - select key.
 * @return {any} The selected diamond pack data.
 */
const getDiamondPackData = createCachedSelector(
  (state, id) => state.getIn(['diamondPacks', id]),
  (state, id, dataKey) => dataKey,
  state => getRemoteConfigData(state, SHOP_REWARD_BADGES),
  (diamondPack, dataKey, rewardBadgesString) => {
    let result = undefined;
    if (!diamondPack) {
      return result;
    }
    result = diamondPack.get(dataKey);
    if ('badges' === dataKey) {
      result = diamondPack.getIn(['context', 'badges']);
    } else if ('badge' === dataKey) {
      result = diamondPack.getIn(['context', 'badges'])?.join(':');
    } else if ('primaryBadge' === dataKey) {
      result = diamondPack.getIn(['context', 'primaryBadge']) || [];
    } else if ('secondaryBadge' === dataKey) {
      result = diamondPack.getIn(['context', 'secondaryBadge']) || [];
    } else if ('modifiers' === dataKey) {
      result = diamondPack.getIn(['context', 'modifiers']) || {};
    } else if ('soldCount' === dataKey) {
      result = diamondPack.getIn(['context', 'sold']);
    } else if ('passType' === dataKey) {
      result = diamondPack.getIn(['context', 'pass_type']);
    } else if ('restrictionUserLevel' === dataKey) {
      result = diamondPack.getIn(['context', 'restriction_user_level']);
      // diamonds amount.
    } else if ('amount' === dataKey) {
      result = diamondPack.getIn(['context', 'amount']);
    } else if ('noticeTemplateId' === dataKey) {
      result = diamondPack.getIn(['context', 'notice_template_id']);
    } else if ('isReward' === dataKey) {
      const primaryBadges =
        diamondPack.getIn(['context', 'primaryBadge']) || [];
      const rewardBadges = rewardBadgesString.split(' ');
      result = !!primaryBadges.find(badge => rewardBadges.includes(badge));
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, id, dataKey) => `${id}:${dataKey}`);

export default getDiamondPackData;
